$(document).ready(function () {
    console.log("ready from login");
  
   $("#create-membership").click(function(){
      $("#create-membership").addClass("disabled");
      var href = $(this).attr("data-href");
      var isValid = true;
      console.log("creando membresia");
      console.log(href);
  
  
      $("#pet-type,#pet-weight,#birthdatePet").removeClass("err-field");
  
      if($("#pet-type").val() == ""){
        $("#pet-type").addClass("err-field");
        isValid = false;
      }
      if($("#pet-weight").val() == ""){
        $("#pet-weight").addClass("err-field");
        isValid = false;
      }
     // if($("#pet-size").val() == ""){
       // $("#pet-size").addClass("err-field");
        //isValid = false;
      //}
      //if($("#owner-size").val() == ""){
       // $("#owner-size").addClass("err-field");
        //isValid = false;
      //}
      if($("#birthdatePet").val() == ""){
        $("#birthdatePet").addClass("err-field");
        isValid = false;
      }
      if($("#documentNumber").val() == ""){
        $("#documentNumber").addClass("err-field");
        isValid = false;
      }
      if($("#cities").val() == "null"){
        $("#cities").addClass("err-field");
        isValid = false;
      }
      if($("#neighborhoods").val() == "" || $("#neighborhoods").val() == ""){
        $("#neighborhoods").addClass("err-field");
        isValid = false;
      }
  
      if(isValid == false){
        alert("Datos incompletos, por favor verifique");
        $("#create-membership").removeClass("disabled ");
        return;
      }
  
      var wrapper = {
        "ShopId": Shopify.shop,
        "ClientId": $("#customer_id").val(),
        "ClientName": $("#customer_name").val(),
        "ClientEmail": $("#customer_email").val(),
        "Name": $("#membership_name").val(),
        "Description": $("#membership_desc").val(),
        "Type": $("#membership_type").val(),
        "MembershipId": $("#membership_id").val(),
        "Discount": parseInt($("#membership_discount").val()),
        "InitialDate": new Date(parseInt($("#membership_idate").val() * 1000)).toISOString(),
        "FinalDate": new Date(parseInt($("#membership_fdate").val() * 1000)).toISOString(),
        "PetType": $("#pet-type").val(),
        "PetWeight": $("#pet-weight").val(),
        "BirthdatePet": document.getElementById('birthdatePet').valueAsDate,
        "PetSize": $("#pet-size").val(),
        "OwnerSize": $("#owner-size").val()
      };
  
      console.log(wrapper);
  
      $.ajax({
        //url: "https://suscripciones.azurewebsites.net/api/Membership/SaveMembership",
        url: "https://integraciones.tierragro.com:3002/membresia/insertFormulario",
        type: "POST",
        data: JSON.stringify(wrapper),
        contentType: "application/json;charset=utf-8",
        success: function (data) {
          if (data != null && data.ok == true) {
            console.log("subscription created");
            console.log(data);
  
            var parameters = "?attributes[membership]=" + data.msg;
            parameters += "&attributes[departamento]=" + $("#provincesSelect").val();
            parameters += "&attributes[ciudad]=" + $("#cities").val();
            parameters += "&attributes[nombre-ciudad]=" + $( "#cities option:selected" ).text();
            parameters += "&attributes[barrio]=" + $("#neighborhoods").val();
            parameters += "&attributes[nombre-barrio]=" +$( "#neighborhoods option:selected" ).text();
            parameters += "&attributes[Tipo de documento]=" + $("#tipo-de-documento").val();
            parameters += "&attributes[documento]=" + $("#documentNumber").val();
  
            window.location.href = href + parameters;
  
          }
          else {
            alert("Error");
            $("#"+id+"Loading").hide();
            $("#"+id).show();
          }
  
          console.log(data);
  
        },
        error: function (msg) {
          console.log(msg);
          alert("Error");
          $("#"+id+"Loading").hide();
          $("#"+id).show();
        }
      });
  
  
    });  	
  });
  
  function getMemberships(clientId){
    var template = '<tr> <td><a href="#HREF#" class="link link--accented">#NAME#</a></td><td>#STATUS#</td><td>#INITIAL#</td><td>#FINAL#</td></tr>';
  
    $.ajax({
      url: "https://suscripciones.azurewebsites.net/api/Membership/GetMemberships/" + clientId,
      type: "GET",
      contentType: "application/json;charset=utf-8",
      success: function (data) {
        if (data != null ) {
          console.log(data);
          $("#subscriptions_account").text(data.length);
          for(var i = 0; i < data.length; i++){
            var item = data[i];
            var record = template.replace("#NAME#", item.name);
            var initialDate = moment(item.initialDate);
            var finalDate = moment(item.finalDate);    
  
            record = record.replace("#STATUS#", item.status);
            record = record.replace("#INITIAL#",initialDate.format("DD-MM-YYYY") );
            record = record.replace("#FINAL#", finalDate.format("DD-MM-YYYY") );
  
            $("#body-memberships").append(record);
          }
        }
        else {
          alert("Error");
          $("#"+id+"Loading").hide();
          $("#"+id).show();
        }
  
      },
      error: function (msg) {
        console.log(msg);
        alert("Error");
        $("#"+id+"Loading").hide();
        $("#"+id).show();
      }
    });
  }
  
  function getMembershipsService(clientId){
    var template = '<tr> <td>#NAME#</td><td>#STORE#</td><td>#DATE#</td><td>#MEMBERSHIP#</td></tr>';
  
    $.ajax({
      url: "https://suscripciones.azurewebsites.net/api/Membership/GetServices/" + clientId,
      type: "GET",
      contentType: "application/json;charset=utf-8",
      success: function (data) {
        if (data != null ) {
          console.log(data);
          $("#subscriptions_account-services").text(data.length);
          for(var i = 0; i < data.length; i++){
            var item = data[i];
            var record = template.replace("#NAME#", item.serviceName);
            var date = moment(item.creationDate);
  
  
            record = record.replace("#STORE#", item.storeName);
            record = record.replace("#DATE#", date.format("DD-MM-YYYY"));
            record = record.replace("#MEMBERSHIP#", item.membershipName);
  
            $("#body-memberships-services").append(record);
          }
        }
        else {
          alert("Error");
          $("#"+id+"Loading").hide();
          $("#"+id).show();
        }
  
      },
      error: function (msg) {
        console.log(msg);
        alert("Error");
        $("#"+id+"Loading").hide();
        $("#"+id).show();
      }
    });
  }
  
  function getMembershipsServiceNoUsed(clientId){
    var template = '<tr> <td>#NAME#</td><td>#USED#</td><td>#AVAILABLE#</td><td>#MEMBERSHIP#</td></tr>';
  
    $.ajax({
      url: "https://suscripciones.azurewebsites.net/api/Membership/GetServicesNoUsed/" + clientId,
      type: "GET",
      contentType: "application/json;charset=utf-8",
      success: function (data) {
        if (data != null ) {
          console.log(data);
          $("#subscriptions_account-services-no").text(data.length);
          for(var i = 0; i < data.length; i++){
            var item = data[i];
            var record = template.replace("#NAME#", item.name);
            var date = moment(item.creationDate);
  
            record = record.replace("#USED#", item.used);
            record = record.replace("#AVAILABLE#", item.available > 100?"100+":item.available);
            record = record.replace("#MEMBERSHIP#", item.membershipName);
            $("#body-memberships-services-no").append(record);
          }
        }
        else {
          alert("Error");
          $("#"+id+"Loading").hide();
          $("#"+id).show();
        }
  
      },
      error: function (msg) {
        console.log(msg);
        alert("Error");
        $("#"+id+"Loading").hide();
        $("#"+id).show();
      }
    });
  }
  
  function updateCartAttr(attributes, callback){
    fetch("".concat("/cart", "/update.js"), {
      body: JSON.stringify(attributes),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
      }
    }).then(function (response) {
      if(callback){
        callback();
      }
    });
  }
  
  function setWithExpiry(key, value, ttl) {
    const now = new Date()
  
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }
  
  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }